import type { IAnonymousAuthCmd } from "@/data/commands/auth/AnonymousAuthCmd";
import type { IGetSessionByTransactionCmd } from "@/data/commands/auth/GetSessionByTransactionCmd";
import type { IResetPasswordCmd } from "@/data/commands/auth/ResetPasswordCmd";
import type { ISendPasswordResetCmd } from "@/data/commands/auth/SendPasswordResetCmd";
import type { ISignoutCmd } from "@/data/commands/auth/SignoutCmd";
import type { ISignupCmd } from "@/data/commands/auth/SignupCmd";
import type { IUsernamePasswordAuthCmd } from "@/data/commands/auth/UsernamePasswordAuthCmd";
import type { ITokenResult } from "@/data/model/Authorization";

import { BaseServiceDao } from "./BaseServiceDao";

export class AuthenticationDao extends BaseServiceDao {
    public static className = "AuthenticationDao";

    constructor() {
        super("auth");
    }

    public async auth(cmd: IUsernamePasswordAuthCmd): Promise<ITokenResult> {
        return this.post("", cmd, AuthenticationDao.parseTokenResult);
    }

    public async authAnonymous(cmd: IAnonymousAuthCmd): Promise<ITokenResult> {
        return this.post("anonymous", cmd, AuthenticationDao.parseTokenResult);
    }

    public async signOut(cmd: ISignoutCmd = {}): Promise<void> {
        return this.post("signout", cmd);
    }

    public async signup(cmd: ISignupCmd): Promise<ITokenResult> {
        return this.post("signup", cmd, AuthenticationDao.parseTokenResult);
    }

    public async sendPasswordReset(cmd: ISendPasswordResetCmd): Promise<ITokenResult> {
        return this.post("sendpwreset", cmd);
    }

    public async resetPassword(cmd: IResetPasswordCmd): Promise<ITokenResult> {
        return this.post("resetpassword", cmd);
    }

    public async getSessionByTransactionId(cmd: IGetSessionByTransactionCmd): Promise<ITokenResult> {
        return this.post("session-by-transaction", cmd, AuthenticationDao.parseTokenResult);
    }

    public static parseTokenResult(literal: any): ITokenResult {
        return {
            bearer: literal.bearer,
            identityId: literal.identityId,
            deviceHash: literal.deviceHash == null ? undefined : literal.deviceHash,
            roles: literal.roles,
            operatorLocations: literal.operatorLocations,
        };
    }
}
